import React from "react";
import { Link } from "react-router-dom";
import "./Pages.css";

function Privacy() {
  return (
    <article className="page-content">
      <h1>Privacy &amp; Legal</h1>

      <h2>Informational and Record-Keeping Use Only</h2>
      <p>
        CountyLee is an out-of-county mileage calculator provided for informational and record-keeping purposes only. It is not intended as financial, tax, or legal advice. Reimbursement rates, tax deductions, and employer policies vary. You should confirm any reimbursement amounts, rates, or record-keeping requirements with your employer, accountant, or qualified advisor before relying on the results for payroll, expenses, or taxes.
      </p>

      <h2>Privacy and Your Data</h2>
      <p>
        When you use the calculator, you enter start and end addresses in your browser. Address and location data are used only to perform the mileage calculation (e.g., geocoding and route data) via third-party services. We do not collect or store your addresses or trip details on our own servers. We do not sell your data. For full details, check the privacy policies of any third-party services used by the site (such as map or routing providers). Use of the site indicates acceptance of these terms.
      </p>

      <h2>Accuracy and Availability</h2>
      <p>
        CountyLee uses public map and county boundary data to compute mileage and county information. While we aim for accuracy, we do not guarantee that the results are error-free or suitable for any particular use. The site and tool are provided &quot;as is.&quot; We are not liable for any decisions you make based on the calculated mileage or other output. The site may be modified or unavailable from time to time without notice.
      </p>

      <h2>Contact</h2>
      <p>
        For questions about this page or the tool, contact <a href="mailto:leatonm@gmail.com">leatonm@gmail.com</a>. For more about CountyLee, see our <Link to="/about">About</Link> and <Link to="/faq">FAQ</Link> pages.
      </p>
    </article>
  );
}

export default Privacy;
